import { SettingsPermissions } from "@redotech/account-common/permissions";
import { t } from "@redotech/redo-i18n";
import { PermissionedRouteObject } from "@redotech/redo-merchant-app-common/routing/protected-routes";

export const paymentsSettingsRoutes: PermissionedRouteObject = {
  handle: {
    get breadcrumb() {
      return t("Payments");
    },
    breadcrumbNavigate: false,
    permission: SettingsPermissions.SET_CHECKOUT_OPTIMIZATION_SETTINGS,
  },
  path: "payments",
  children: [
    {
      path: "hsa",
      handle: {
        get breadcrumb() {
          return t("HSA/FSA");
        },
        permission: SettingsPermissions.SET_CHECKOUT_OPTIMIZATION_SETTINGS,
      },
      lazy: async () => {
        const { HsaSettingsPage } =
          await import("../../../../setting/conversion/hsa/hsa-settings-page");
        return { Component: HsaSettingsPage };
      },
    },
  ],
};
